import loadSegmentSDK from "./SegmentSDK";
import {asyncCall, getIdentityTraits} from "../util";
import BrowserInteractionTime from 'browser-interaction-time';
import { getExtendData, testIsValidUser } from "../util";

const targetStorage = localStorage;

export default class SpendTimeTrack {

	static getCurrentStorages(withClean) {
		let page2timeMap = {}
		Object.entries(targetStorage).forEach(function (pair) {
			const key = pair[0];
			const value = pair[1];
			if(key.indexOf(SpendTimeTrack.storageKeyPrefix) === 0) {
				const pageName = key.replace(SpendTimeTrack.storageKeyPrefix, '');
				page2timeMap[pageName] = value * 1;

				if(withClean) {
					targetStorage.removeItem(key)
				}
			}
		})
		return page2timeMap;
	}

	constructor(pageName, segmentApiKey) {
		this.pluginName = 'SpendTimeTrack';
		this.browserInteractionTime = new BrowserInteractionTime({
			idleTimeoutMs: 3000,
			checkCallbacksIntervalMs: 1000
		})
		if(!testIsValidUser()){
			console.error('Internal User, not track');
			return
		}
		this.pageName = pageName;
		this.API_KEY = segmentApiKey;
		this.unbindEvents();


		SpendTimeTrack.subs.add(this.bindBeforeUnloadEvent());
		SpendTimeTrack.subs.add(this.bindPageChangeEvent());
		SpendTimeTrack.subs.add(this.bindSpaPageChangeEvent());

		this.start();
		asyncCall(() => sendDelayedPayload(this.API_KEY))
	}

	get spendTime() {
		return parseInt(this.browserInteractionTime.getTimeInMilliseconds() / 1000)
	}

	start() {
		this.browserInteractionTime.startTimer()
	}
	reset() {
		this.browserInteractionTime.reset()
	}

	save2Storage() {
		if (!this.pageName) {
			return
		}
		let t = this.spendTime;
		const page2timeMap = SpendTimeTrack.getCurrentStorages(false);
		t = t + (page2timeMap[this.pageName] || 0);
		if(t > 0) {
			targetStorage.setItem(`${SpendTimeTrack.storageKeyPrefix}${this.pageName}`, t);
		}
	}

	sendCurrentSpend(pageName) {
		pageName = pageName || this.pageName
		if (!pageName) {
			return
		}
		const spendTime = this.spendTime;
		this.reset();
		let analytics = window.analytics;
		if(!analytics) {
			return
		}
		sendPayload(pageName, spendTime);
	}

	setPageName(pageName) {
		this.pageName = pageName;
	}

	bindBeforeUnloadEvent() {
		const cb = () => this.save2Storage();
		window.addEventListener("beforeunload", cb);
		return () => window.removeEventListener("beforeunload", cb);
	}

	bindPageChangeEvent() {
		const cb = (evt) => {
			this.sendCurrentSpend(evt && evt.detail && evt.detail.pageName)
		};
		// 触发方式: window.dispatchEvent(new CustomEvent('pageChange',{detail: {pageName: 'HOME'}}) )
		window.addEventListener('pageChange', cb, { passive: true })
		return  () => window.removeEventListener('pageChange', cb);
	}

	bindSpaPageChangeEvent() {
		const cb = (evt) => {
			this.sendCurrentSpend()
			if (evt && evt.detail && evt.detail.toPageName) {
				this.setPageName(evt.detail.toPageName)
			}
		};
		// 触发方式: window.dispatchEvent(new CustomEvent('SpaPageChange',{detail: {toPageName: 'HOME'}}) )
		window.addEventListener("SpaPageChange", cb, { passive: true });
		return () => window.removeEventListener("SpaPageChange", cb);
	}

	unbindEvents() {
        SpendTimeTrack.subs.forEach(cb => cb());
        SpendTimeTrack.subs.clear();
    }
}

SpendTimeTrack.subs = new Set();

SpendTimeTrack.storageKeyPrefix = 'ps-timetrack-plugin:';

export async function sendDelayedPayload(API_KEY) {
	await loadSegmentSDK(API_KEY)
	const page2timeMap = SpendTimeTrack.getCurrentStorages(true);
	let analytics = window.analytics;
	if(!analytics) {
		return
	}
	Object.keys(page2timeMap).forEach(function (pageName) {
		sendPayload(pageName, page2timeMap[pageName])
	})
}


function sendPayload(pageName, spend) {
	if(spend <= 0) {
		return
	}
	const extendData = getExtendData();
	const idt = getIdentityTraits();
	const traits = Object.assign({
		page: pageName,
		product: extendData.product,
		spend: spend,
	}, idt);
	analytics.track('Track Time', traits, {
		integrations: {
			'All': false,
			'redshift-segmentdb': true,
			'Redshift': true,
			'Amazon Kinesis': true,
			'amazon-kinesis': true
		}
	});
}
